export default __webpack_public_path__ + "static/media/sidebar-compositions.369dd629.svg";